const CircleSection = () => {
  return (
    <section
      className="w-full"
      style={{
        height: '600px',
        paddingLeft: 'clamp(16px, 5vw, 64px)',
        paddingRight: 'clamp(16px, 5vw, 64px)',
        paddingTop: 'clamp(32px, 8vw, 64px)',
        paddingBottom: 'clamp(32px, 8vw, 64px)',
        backgroundImage: 'url("/Landing Page/Circle Like No Other/Top.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div className="w-full text-center">
        <h2
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: 'clamp(24px, 5vw, 32px)',
            color: '#FFFFFF',
            fontWeight: '400',
            marginBottom: 'clamp(8px, 2vw, 16px)',
            textAlign: 'center'
          }}
        >
          A Circle Like No Other
        </h2>
        
        <h3
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: 'clamp(24px, 5vw, 32px)',
            color: '#FFFFFF',
            fontWeight: '400',
            marginBottom: 'clamp(16px, 4vw, 80px)',
            textAlign: 'center',
            lineHeight: 'normal'
          }}
        >
          Discover a World of Prestige with FGA's Exclusive Experiences
        </h3>
        
        <p
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: 'clamp(14px, 2.5vw, 16px)',
            color: '#FFFFFF',
            lineHeight: '1.6',
            maxWidth: 'min(800px, 90%)',
            margin: '0 auto',
            textAlign: 'center'
          }}
        >
          We believe time is the ultimate luxury—and we're here to give it back to you. Our member services are meticulously designed to anticipate your needs, fulfill your wishes, and elevate your every day. For over two decades, we've set the gold standard in professional concierge, redefining what it means to live well.
        </p>
      </div>
    </section>
  )
}

export default CircleSection